import {takeEvery} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeEvery(ACTION.SCAN_BARCODE.REQUEST, saga.scanBarcode);
    yield takeEvery(ACTION.SCAN_BARCODE.FAILED, saga.scanBarcodeFailed);
}
